import clsx from 'clsx';

type IndicatorProps = {
  active: boolean;
};

export const Indicator = ({ active }: IndicatorProps) => (
  <span className={clsx('indicator', active ? 'indicator__active' : '')}></span>
);
